import { render, staticRenderFns } from "./history-details-presc-btn.vue?vue&type=template&id=9ebb1ea6&lang=pug&"
import script from "./history-details-presc-btn.vue?vue&type=script&lang=ts&"
export * from "./history-details-presc-btn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports